module.exports = __webpack_public_path__ + "img/bg-init-left.add1c0ad.png";